var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ShareMediaPackageForm',{attrs:{"id":_vm.id,"model-id":_vm.model_id,"view_mode":"full"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }